// Email.js

const normalizeEmailValueForStorage = (value) => String(value ?? '').trim().toLowerCase();

const isProbablyEmailAddress = (value) => {
  const normalized = normalizeEmailValueForStorage(value);
  const atIndex = normalized.indexOf('@');
  return atIndex > 0 && atIndex < normalized.length - 1;
};

const buildMailtoUrl = (value) => {
  const normalized = normalizeEmailValueForStorage(value);
  if (!isProbablyEmailAddress(normalized)) return '';
  return `mailto:${encodeURIComponent(normalized)}`;
};

export {
  buildMailtoUrl,
  isProbablyEmailAddress,
  normalizeEmailValueForStorage,
};